import { useContext, useEffect, useState } from 'react';
import './CallBackPopup.css';
import { ClosePopupIcon } from '../../assets/icons/icons';
import Popup from '../Popup/Popup';
import { ContactContext } from '../../assets/contexts/contactContext';
import { ConfigContext } from '../../assets/contexts/configContext';
import { DEFAULT_SOCIAL_VALUES_MAP, TELEGRAM_SOCIAL, VIBER_SOCIAL, WHATSAPP_SOCIAL } from '../../assets/utils/socials/socials_constants';
import validator from "validator";
import Input from '../Input/Input';
import mainApi from '../../assets/api/MainApi';
import { CONTACT_PHONE, CONTACT_PHONE_2, DEV_SHOP_ID, EN_SITE_URL, OPEN_ITEM_REQUEST, TELEGRAM_CONTACT_LINK, WHATSAPP_CONTACT_LINK } from '../../assets/utils/constants';
import { getCookieWithShop } from '../../assets/utils/utils';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CallBackContext } from '../../assets/contexts/callBackContext';

function CallBackPopup({ personal, setPersonal, setPersonalValidity, personalValidity }) {
  const { isCallBackPopupOpen: isOpen, setCallBackPopupOpen: setOpen } =
    useContext(CallBackContext);

  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { SOCIAL_NETWORKS } = initialConstants

  console.log({ SOCIAL_NETWORKS })

  useEffect(() => {
    if (!isOpen) { document.body.style.overflow = 'initial'; }
    else { document.body.style.overflow = 'hidden'; }
  });


  const FILTERED_SOCIAL_NETWORKS = SOCIAL_NETWORKS && Array.isArray(SOCIAL_NETWORKS) && SOCIAL_NETWORKS.length > 0 ?
    SOCIAL_NETWORKS.filter((item) => {
      if ([TELEGRAM_SOCIAL.type, WHATSAPP_SOCIAL.type, VIBER_SOCIAL.type].indexOf(item.type) >= 0) return true
      else return false
    })
    : null

  function handleChange(e) {
    const input = e.target;
    const name = input.name;
    let value = input.value;

    switch (name) {
      case "phone":
        let inputValue = e.target.value.replace(/\D/g, '')
        let formattedInputValue = '';
        if (!inputValue) {
          setPersonal(prevValue => ({
            ...prevValue,
            [name]: '',
          }))
          setPersonalValidity((prevValue) => ({
            ...prevValue,
            [name]: {
              errorMessage: '',
              validState: false
            }
          }))
        }
        else {
          formattedInputValue = '+' + inputValue.substring(0, 16)
          if (inputValue.length >= 11) {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: '',
                validState: true
              }
            }));
          } else {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: '',
                validState: false
              }
            }));
          }



          setPersonal(prevValue => ({
            ...prevValue,
            [name]: formattedInputValue,
          }))
        }

        break;

      case "email":
        if (!value) {
          setPersonalValidity((prevValue) => ({
            ...prevValue,
            [name]: {
              errorMessage: "",
              validState: false,
            },
          }));
        }
        if (value.length >= 2) {
          if (validator.isEmail(value)) {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: "",
                validState: true,
              },
            }));
          } else {
            setPersonalValidity((prevValue) => ({
              ...prevValue,
              [name]: {
                errorMessage: !e.target.validity.valid
                  ? e.target.validationMessage
                  : "Invalid email",
                validState: false,
              },
            }));
          }
        }
        setPersonal((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;

      default:
        setPersonal((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;
    }
  }

  function handlePhoneDelite(e) {
    if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length === 1) {
      setPersonal(prevValue => ({
        ...prevValue,
        phone: '',
      }))
    }
    if (e.keyCode === 8 && e.target.value.replace(/\D/g, '').length < 11) {
      setPersonalValidity(prevValue => ({
        ...prevValue,
        phone: {
          errorMessage: '',
          validState: false
        }
      }));
    }
  }

  const [constants, setConstants] = useState({
    initialConstants: window.initialConstants,
    productPageTokens: window.productPageTokens,
    cardTokens: window.cardTokens,
    mainLayout: window.mainLayout,
    platfromTokens: window.platfromTokens,
  });
  const PRODUCTION_MODE = process.env.REACT_APP_MODE;
  const shop_id = PRODUCTION_MODE === 'dev' ? DEV_SHOP_ID : constants.initialConstants.SHOP_ID_FOR_API;
  const clientUID = getCookieWithShop('client_uid_', shop_id);
  const location = useLocation()
  console.log(location)
  const [correctSending, setCorrectSending] = useState(false)
  function Submit() {
    mainApi.sendRequestContact({
      name: personal.first_name,
      email: personal.email,
      phone: personal.phone.replace(/\D/g, ''),
    })
      .then(response => {
        setCorrectSending(true)
        setPersonal(prevValue=>({
          ...prevValue,
          first_name: '',
          email: '',
          phone: '',
        }))
        setPersonalValidity(prevValue=>({
          ...prevValue,
          email: {},
          phone: {},
        }))
        console.log('Успешный запрос', response)
      })
      .catch(error => {
        console.error('Ошибка запроса', error)
        setCorrectSending(false)
      });
  }

  function closePopup() {
    setOpen(false);
    setTimeout(() => {
      setCorrectSending(false)
    }, 300);
  }

  return (
    <Popup className="call-back-popup" popupName={'call-back-popup'} onClose={closePopup} {...{ setOpen, isOpen }}>
      {!correctSending ?
        <>
          <button
            className="call-back-popup__close-btn"
            type="button"
            onClick={closePopup}
          >
            <ClosePopupIcon
              mainClassName="call-back-popup__close-icon"
              strokeClassName="call-back-popup__close-icon-stroke"
            />
          </button>
          <div className="call-back-popup__content">
            <p className="call-back-popup__title">Request a consultation</p>
            <div className='call-back-popup__inputs-box'>
              <div className="personal-info__input">
                <Input
                  label={"Name"}
                  value={personal.first_name}
                  handleChange={handleChange}
                  name={"first_name"}
                // error={formValid.email}
                ></Input>
              </div>
              <div className="personal-info__input">
                <Input
                  label={"Phone Number"}
                  value={personal.phone}
                  handleChange={handleChange}
                  name={"phone"}
                  inputMode='tel'
                  error={personalValidity.phone}
                  onKeyDown={handlePhoneDelite}
                ></Input>
              </div>
              <div className="personal-info__input">
                <Input
                  label={"E-mail"}
                  value={personal.email}
                  handleChange={handleChange}
                  name={"email"}
                  inputMode='email'
                // error={personalValidity.email}
                ></Input>
              </div>
            </div>
            <button onClick={() => Submit()} className={`call-back-popup__btn-submit ${!(personal.first_name && personal.phone && personalValidity.phone.validState && personal.email && personalValidity.email.validState) ? 'call-back-popup__btn-submit_invalid' : ''}`}>Request</button>
            <div className='call-back-popup__contact-separator-box'>
              <p className='call-back-popup__contact-separator-box__contact'>Or Contact</p>
              <div className='call-back-popup__contact-separator-box__separator'></div>
            </div>
            <div className='call-back-popup__items'>
              <a className='call-back-popup__item' href={TELEGRAM_CONTACT_LINK} target='_blank' rel='noreferrer'>
                {TELEGRAM_SOCIAL.icon({
                  mainClassName: 'call-back-popup__item-icon',
                  fillClassName: 'call-back-popup__item-icon-fill',
                  bgFillClassName: 'call-back-popup__item-icon-bg-fill',
                })}
                <h3>{TELEGRAM_SOCIAL.title}</h3>
              </a>
              <a className='call-back-popup__item' href={WHATSAPP_CONTACT_LINK} target='_blank' rel='noreferrer'>
                {WHATSAPP_SOCIAL.icon({
                  mainClassName: 'call-back-popup__item-icon',
                  fillClassName: 'call-back-popup__item-icon-fill',
                  bgFillClassName: 'call-back-popup__item-icon-bg-fill',
                })}
                <h3>{WHATSAPP_SOCIAL.title}</h3>
              </a>
            </div>
            <div className='call-back-popup__phone-box'>
              <p className='call-back-popup__phone-box__text'>Phone:</p>
              <a className='call-back-popup__phone-box__phone' href={`tel:${CONTACT_PHONE.value}`}>{CONTACT_PHONE.formated}</a>
              {/* <a className='call-back-popup__phone-box__phone' href={`tel:${CONTACT_PHONE_2.value}`}>{CONTACT_PHONE_2.formated}</a> */}
            </div>
          </div>
        </>
        :
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className='call-back-popup__submit-send-box'
        >
          <p className='call-back-popup__submit-send-box__title'>
            Your Request<br></br>
            Has Been Submitted
          </p>
          <p className='call-back-popup__submit-send-box__text'>
            Thank you for reaching out!
            We&rsquo;ll get back to&nbsp;you shortly
            with more information
          </p>
          <button onClick={closePopup} className='call-back-popup__submit-send-box__btn'>
            OK
          </button>
        </motion.div>
      }
    </Popup>
  );
}

export default CallBackPopup;
